import type { LocalDatabaseReceipt } from "../../../_Generated/Sync.gen";
import type { BaseReceiptRepository } from "../../_Bases/BaseReceiptRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBReceiptRepository extends BaseIndexedDBRepository<
    LocalDatabaseReceipt
> implements BaseReceiptRepository {
    public readonly source: InternalIndexedDBDatabase["receipts"];
    protected readonly dataTypeName = "Receipt";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.receipts;
    }

    public filter(filter: (item: LocalDatabaseReceipt) => boolean): Promise<Array<LocalDatabaseReceipt>> {
        return this.source.filter(filter).toArray();
    }

    public getByType(type: string): Promise<Array<LocalDatabaseReceipt>> {
        return this.source.where("type").equals(type).toArray();
    }
}
